import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/ai-scale-hq/30min';

export const FinalCTASection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <section
      ref={sectionRef}
      className="py-24 relative"
      data-testid="final-cta-section"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Ready to Close More
            <br />
            <span className="text-[#6C4DFF]">From the Leads You Already Have?</span>
          </h2>

          <p className="text-lg text-white/60 mb-8 max-w-xl mx-auto">
            Book a call. We'll show you where leads are slipping through 
            and how we can help capture more revenue.
          </p>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2 text-lg px-8 py-4"
            data-testid="final-cta-button"
          >
            <Calendar className="w-5 h-5" />
            Book a Strategy Call
            <ArrowRight className="w-5 h-5" />
          </a>

          <p className="text-sm text-white/40 mt-6">
            No commitment. Just a conversation about your pipeline.
          </p>

          {/* Final reminder stat */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-10 pt-8 border-t border-white/5"
          >
            <p className="text-sm text-white/40">
              Remember: <span className="text-white/60">62% of unanswered callers</span> contact a competitor.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
